import SeedLabelSubmissionItem from "@/types/SeedLabelSubmission/SeedLabelSubmissionItem";
import BaseEntity from "@/types/BaseEntity";

export default class ClassSubmission extends BaseEntity {
  submissions: Array<SeedLabelSubmissionItem> = [];
}
